import React from 'react';
import PropTypes from 'prop-types';

import { TableCell as MUITableCell } from '@mui/material';

export const TableCell = props => <MUITableCell {...props} />;

TableCell.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  classes: PropTypes.object,
  colSpan: PropTypes.number,
  component: PropTypes.elementType,
  padding: PropTypes.oneOf(['default', 'checkbox', 'none']),
  scope: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['head', 'body', 'footer'])
};

export default TableCell;
